import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useUpdateUpload = (queryClient, theme, onSuccessCallback) => {
    const { mutate: updateUpload, status: updateStatus, isPending: isUpdating } = useMutation({
        mutationFn: (data) => api.upload.updateUpload(data),
        onSuccess: (data) => {
            toast.success(data?.message || 'Upload updated successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Upload update failed', { ...toastStyles, theme: theme });
        }
    });

    return { updateUpload, isUpdating, updateStatus };
}